export enum DisplayType {
    // Primitive types
    DECIMAL = "decimal",
    FLOAT = "float",
    INTEGER = "int",
    STRING = "string",

    // Date/Time types
    DATE = "date",
    DATERANGE = "daterange",
    DATETIME = "datetime",
    TIME = "time",

    // Currency
    CURRENCY = "currency",

    // Specialty number types
    DISTANCE = "distance",
    LENGTH = "length",
    TEMPERATURE = "temperature",
    VOLUME = "volume",
    WEIGHT = "weight",

    // Other field-specific types
    CITY = "city",
    COLOR = "color",
    EMAIL = "email",
    LINK = "link",
    LOCATION = "location",
    PERCENTAGE = "percentage",
    PHONE = "phone",
    STATE = "state"
}

export class DisplayTypeUtil {
    private static readonly RIGHT_ALIGNED_DISPLAY_TYPES = [
        DisplayType.CURRENCY,
        DisplayType.DECIMAL,
        DisplayType.DISTANCE,
        DisplayType.FLOAT,
        DisplayType.INTEGER,
        DisplayType.LENGTH,
        DisplayType.PERCENTAGE,
        DisplayType.TEMPERATURE,
        DisplayType.VOLUME,
        DisplayType.WEIGHT
    ];
    private static readonly DATE_DISPLAY_TYPES = [
        DisplayType.DATE,
        DisplayType.DATETIME,
        DisplayType.TIME
    ];

    public static isRightAlignedDisplayType(displayType: DisplayType) {
        return this.RIGHT_ALIGNED_DISPLAY_TYPES.includes(displayType);
    }

    public static displaysDateOrTime(displayType: DisplayType, includeDateRange = true) {
        return DisplayTypeUtil.DATE_DISPLAY_TYPES.includes(displayType) ||
            (includeDateRange && displayType === DisplayType.DATERANGE);
    }

    public static isDisplayTypeNumeric(type: DisplayType) {
        return (type === DisplayType.INTEGER
            || type === DisplayType.DECIMAL
            || type === DisplayType.FLOAT
            || type === DisplayType.CURRENCY
            || type === DisplayType.WEIGHT
            || type === DisplayType.DISTANCE
            || type === DisplayType.PERCENTAGE
            || type === DisplayType.LENGTH
            || type === DisplayType.TEMPERATURE);
    }
}
